import { useTranslate } from "@tolgee/react";
import {
	formatDateTime,
	formatUsd,
	formatWalletAddress,
} from "#/lib/formatters";
import { useMyReferralStats } from "../hooks/use-my-referral-stats";

export function ReferralsList() {
	const { t } = useTranslate();
	const stats = useMyReferralStats();
	const rows = stats.data?.referred_traders ?? [];

	return (
		<section>
			<div className="mb-2">
				<h2 className="text-headline text-foreground">
					{t("referrals.list.title")}
				</h2>
			</div>

			{rows.length === 0 ? (
				<p className="px-5 py-8 text-center text-body2 text-muted-foreground">
					{t("referrals.list.empty")}
				</p>
			) : (
				<div className="overflow-x-auto">
					<table className="w-full text-body2">
						<thead className="text-label2-medium text-muted-foreground">
							<tr className="border-b border-border">
								<th className="px-5 py-3 text-left">
									{t("referrals.list.columns.wallet")}
								</th>
								<th className="px-5 py-3 text-left">
									{t("referrals.list.columns.joined")}
								</th>
								<th className="px-5 py-3 text-right">
									{t("referrals.list.columns.volume")}
								</th>
								<th className="px-5 py-3 text-right">
									{t("referrals.list.columns.earned")}
								</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row) => (
								<tr
									key={row.wallet}
									className="border-b border-border last:border-b-0"
								>
									<td className="px-5 py-3 text-foreground">
										{formatWalletAddress(row.wallet)}
									</td>
									<td className="px-5 py-3 text-muted-foreground">
										{formatDateTime(Date.parse(row.joined_at))}
									</td>
									<td className="px-5 py-3 text-right text-label1-tabular text-foreground">
										{formatUsd(row.volume_usd)}
									</td>
									<td className="px-5 py-3 text-right text-label1-tabular text-foreground">
										{formatUsd(row.earned_usd)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
		</section>
	);
}
